export const endpoint = 'https://backoffice.camminidellafede.it/api/'
